import { render, staticRenderFns } from "./ApplicationReviewCollection.vue?vue&type=template&id=6fb01226&scoped=true&"
import script from "./ApplicationReviewCollection.vue?vue&type=script&lang=js&"
export * from "./ApplicationReviewCollection.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationReviewCollection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ApplicationReviewCollection.vue?vue&type=style&index=1&id=6fb01226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb01226",
  null
  
)

export default component.exports